<button class="btn btn-outline-gray btn-block br-0 d-flex align-items-center px-4 justify-content-center" [disabled]="disabled">
  <i class="text-green mr-2" [ngClass]="iconClass" *ngIf="iconClass != ''"></i>{{ buttonText }}
</button>
